import { Component, inject } from "@angular/core";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { Observable, of, firstValueFrom } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { ThirdPartyDataService } from "@pages/thirdparty/services/ThirdPartyDataService";
import { RendererConfig } from "@models/workspace/RendererConfig";
import { RendererType } from "@enums/RendererType";
import { TranslocoService, provideTranslocoScope } from "@jsverse/transloco";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "thirdparty-linkable",
    templateUrl: "./thirdparty-linkable.component.html",
    imports: [LinkableComponent],
    providers: [provideTranslocoScope("thirdparty")],
})
export class ThirdPartyLinkableComponent extends ItemLinkableBase {
    hasAccessChecks = {};
    accessCheckInProgress = false;

    rendererConfig: RendererConfig[] = [
        {
            textColumn: "Review score",
            actionColumn: "ReviewScoreColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
        {
            textColumn: "Criticality",
            actionColumn: "CriticalityColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
    ];

    private _tpDataService = inject(ThirdPartyDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translocoService = inject(TranslocoService);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._tpDataService.hasAccess(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.ThirdpartyDetail,
                item.guid,
                `(TP) ${item[this.displayValueProp]}`
            );
        } else {
            // Nothing in this template uses the transloco pipe/directive, so the lazy scope
            // is not loaded yet and a synchronous translate() would return the raw key.
            await firstValueFrom(
                this._translocoService.load(`thirdparty/${this._translocoService.getActiveLang()}`)
            );
            this._toastr.warning(
                this._translocoService.translate("thirdparty.thirdpartyLinkable.notEnoughRights")
            );
        }
    }
}
